import React from "react";
import { DatePicker, Flex, Grid, Input, Select, Space, Button } from "antd";
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import type { Dayjs } from "dayjs";
import { useLanguage } from "src/providers/LanguageProvider";

const { RangePicker } = DatePicker;
const { useBreakpoint } = Grid;

type PaymentStatus = "all" | "paid" | "unpaid";

type Props = {
  query: string;
  onQuery: (v: string) => void;
  /** Only Paid / Unpaid filter */
  status: PaymentStatus;
  onStatus: (v: PaymentStatus) => void;

  // currency props kept for compatibility (not rendered)
  currency?: "all" | string;
  onCurrency?: (v: "all" | string) => void;

  dateRange: [Dayjs | null, Dayjs | null] | null;
  onDateRange: (v: [Dayjs | null, Dayjs | null] | null) => void;
  currencyOptions?: string[];

  loading?: boolean;
  onRefresh?: () => void;
};

export default function FiltersBar({
  query, onQuery, status, onStatus,
  dateRange, onDateRange,
  loading, onRefresh
}: Props) {
  const screen = useBreakpoint();
  const narrow = !screen.md;
  const { t } = useLanguage();

  return (
    <Flex gap={8} wrap align="stretch" style={{ width: "100%" }}>
      <Input
        allowClear
        prefix={<SearchOutlined />}
        placeholder={t("SEARCH_DOC_OR_TXN")}
        value={query}
        onChange={(e) => onQuery(e.target.value)}
        style={{ flex: "1 1 260px", minWidth: 220 }}
        aria-label={t("SEARCH_DOC_OR_TXN")}
      />

      {/* Paid / Unpaid only */}
      <Select<PaymentStatus>
        value={status}
        onChange={onStatus}
        style={{ width: 180, flex: "0 0 180px" }}
        options={[
          { value: "all", label: t("FILTER_STATUS_ALL") },
          { value: "paid", label: t("FILTER_STATUS_PAID") },
          { value: "unpaid", label: t("FILTER_STATUS_UNPAID") }
        ]}
        aria-label={t("FILTER_STATUS_ALL")}
      />

      <RangePicker
        allowEmpty={[true, true]}
        value={dateRange as any}
        onChange={(v) => onDateRange(v as any)}
        placeholder={[t("DATE_START"), t("DATE_END")]}
        style={{ flex: "1 1 260px", minWidth: narrow ? 220 : 260 }}
      />

      <Space.Compact style={{ flex: "0 0 auto" }}>
        <Button icon={<ReloadOutlined />} loading={loading} onClick={onRefresh}>
          {t("BTN_REFRESH")}
        </Button>
      </Space.Compact>
    </Flex>
  );
}
